var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralFeatureSaveBlack = function SvgGeneralFeatureSaveBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M16.41 21.836a2.22 2.22 0 0 0 2.451.487 2.215 2.215 0 0 0 1.389-2.079V1.5H3.75v18.744c0 .928.532 1.724 1.389 2.079s1.796.169 2.467-.503L12 17.164zm1.075-1.046L12 14.978l-5.469 5.797a.74.74 0 0 1-.818.162.74.74 0 0 1-.463-.693V3h13.5v17.244a.735.735 0 0 1-.463.693c-.108.045-.489.166-.802-.147",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralFeatureSaveBlack;